/* eslint-disable */
import React, { forwardRef, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { gsap, TweenMax, TimelineMax, Quart, Expo, Back, Linear } from 'gsap/all';

const propTypes = {
	color: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
	]),
	stroke: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
	]),
	stripes: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
	]),
};

const defaultProps = {
	color: false,
	stroke: false,
	stripes: false,
};

export const FiatBrand = forwardRef(({
	color,
	stroke,
	stripes,
	...props
}, ref) => {
	const stripesRef = useRef([]);

	const renderText = () => (
		<svg
			{...props}
			ref={ref}
			role='group'
			aria-labelledby='fiat-brand-title'
			aria-describedby='fiat-brand-desc'
			xmlns='http://www.w3.org/2000/svg'
			height={'48%'}
			viewBox='0 0 39.791 30.428'>
			<title id="fiat-brand-title">FIAT</title>
			<desc id="fiat-brand-desc">FIAT (Fabbrica Italiana Automobili Torino) é uma das marcas da Fiat Chrysler Automobiles, um dos maiores fabricantes de automóveis do mundo, com sede mundial na cidade de Turim, norte da Itália. A empresa Fiat Automobiles S.p.A foi formada em janeiro de 2007, quando a Fiat reorganizou seus negócios automotivos, e traça a sua história de volta a 1899, quando o primeiro Fiat foi produzido.</desc>
			<g transform='translate(.435 -.36)'>
				<path
					d='M35.848 30.428h-3.6L32.382 3.6h-3.124V.044L39.791 0v3.6h-3.077zm-5.524 0h-3.581v-.078c0-2.158-.082-11.373-.459-13.67h-4.658L21.6 30.414h-3.68L17.555 0h9.118A27.092 27.092 0 0 1 29 6.654a56.023 56.023 0 0 1 1.111 7.666 144.09 144.09 0 0 1 .242 14.486v.008l-.031 1.614zM21.155 3.511l-.089 9.362h4.681c0-.01-.182-1.616-.549-3.541a23.211 23.211 0 0 0-1.723-5.8h-.052c-.229 0-2.249-.02-2.269-.02zm-6.028 26.917H11.15L10.533.009 15.214 0zm-10.856 0L.812 30.39 0 0l8.192.054v3.617H4.219V13H7.3v3.62H4.22l.05 13.8z'
					transform='translate(-.435 .36)'
					style={{
						fill: color,
						stroke: stroke,
					}}
				/>
			</g>
		</svg>
	);

	const renderStripes = () => (
		<svg
			{...props}
			ref={ref}
			role='img'
			aria-hidden={true}
			xmlns='http://www.w3.org/2000/svg'
			height={'48%'}
			viewBox='0 0 43.211 31.401'>
			<path
				ref={(ref) => stripesRef.current[0] = ref}
				d='M10.182 0L0 31.4h4.718L14.9 0z'
				style={{
					fill: stripes === 'italian' ? '#268f52' : stripes,
					stroke: stroke === 'italian' ? '#268f52' : stroke,
				}}
			/>
			<path
				ref={(ref) => stripesRef.current[1] = ref}
				d='M44.382 0L34.2 31.4h4.718L49.1 0z'
				transform='translate(-24.763)'
				style={{
					fill: stripes === 'italian' ? '#ffffff' : stripes,
					stroke: stroke === 'italian' ? '#ffffff' : stroke,
				}}
			/>
			<path
				ref={(ref) => stripesRef.current[2] = ref}
				d='M78.582 0L68.4 31.4h4.718L83.3 0z'
				transform='translate(-49.526)'
				style={{
					fill: stripes === 'italian' ? '#ffffff' : stripes,
					stroke: stroke === 'italian' ? '#ffffff' : stroke,
				}}
			/>
			<path
				ref={(ref) => stripesRef.current[3] = ref}
				d='M112.782 0L102.6 31.4h4.718L117.5 0z'
				transform='translate(-74.289)'
				style={{
					fill: stripes === 'italian' ? '#ff1430' : stripes,
					stroke: stroke === 'italian' ? '#ff1430' : stroke,
				}}
			/>
		</svg>
	);

// 	let stripesTL;
// 	const createStripesTimeline = () => {
// 		stripesTL = new TimelineMax({
// 			paused: true,
// 			smoothChildTiming: true,
// 			onComplete: () => console.log('stripesTL.onTransitionOutComplete'),
// 		})
//
// 		.set(stripesRef.current, {
// 			xPercent: '-20',
// 			autoAlpha: 0,
// 			fill: 'none',
// 			drawSVG: '50% 50%',
// 			strokeWidth: 1,
// 			stroke: '#edede3',
// 			strokeMiterlimit: 10,
// 			strokeDashoffset: 0,
// 		})
//
// 		.set(stripesRef.current[0], {
// 			stroke: stripes === 'italian' ? '#268f52' : '#edede3',
// 		})
//
// 		.set(stripesRef.current[stripesRef.current.length - 1], {
// 			stroke: stripes === 'italian' ? '#ff1430' : '#edede3',
// 		})
//
// 		.staggerTo(stripesRef.current, 1, {
// 			xPercent: 0,
// 			autoAlpha: 1,
// 			// strokeDashoffset: 0,
// 			// fill: '#edede3',
// 			// strokeWidth: 0,
// 			ease: Linear.easeNone,
// 			// delay: 2,
// 		}, 0.25)
//
// 		// .staggerFrom(stripesRef.current, 1, {
// 		// 	x: -100,
// 		// }, 0.75, '-=1')
// 	};
//
// 	const kill = () => {
// 		stripesTL.kill();
// 	};
//
// 	React.useEffect(() => {
// 		createStripesTimeline();
// 		stripesTL.play();
// 		return kill;
// 	}, []);

	return stripes ? renderStripes() : renderText();
});

FiatBrand.displayName = 'FiatBrand';
FiatBrand.propTypes = propTypes;
FiatBrand.defaultProps = defaultProps;
export default FiatBrand;
